import type { PageMeta } from '@/lib/api/types';
import { formatNumber } from '@/lib/format';
import { Button } from './Button';

export function Pagination({ meta, onPage }: { meta?: PageMeta; onPage: (page: number) => void }) {
  if (!meta || meta.pages <= 1) {
    return meta ? <div className="pt-3 text-[11px] text-muted">{formatNumber(meta.total)} سجل</div> : null;
  }
  return (
    <div className="flex items-center justify-between gap-2 pt-4 text-[11px] text-muted">
      <span>
        صفحة {meta.page} من {meta.pages} · {formatNumber(meta.total)} سجل
      </span>
      <div className="flex gap-2">
        <Button size="sm" disabled={meta.page <= 1} onClick={() => onPage(meta.page - 1)}>
          السابق
        </Button>
        <Button size="sm" disabled={meta.page >= meta.pages} onClick={() => onPage(meta.page + 1)}>
          التالي
        </Button>
      </div>
    </div>
  );
}
